import { Card, CardHeader, Row, Col } from 'reactstrap'
import { IconStar } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useFavouriteApps } from '../../_services/_index'
import { appInsights } from '../../_services/AppInsights'
import { EventType } from '../../utility/types'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import styled from 'styled-components'
import AppCtaButton from './AppCtaButton'
import {
  ApplicationIconContainer,
  ApplicationName,
  ApplicationNameContainer,
  CardContainer,
  FavouriteStarContainer,
  Image,
  ButtonContainer,
  RecentlyOpenedContainer
} from './CategoryApps.styled'
import CardTooltip from '../_molecules/CardTooltip'
import { Avatar } from 'dsm-react-lib'
import { useSasToken } from '../../_hooks/useSasToken'

export const CardWrapper = styled(Card)`
  width: 210px;
  height: 240px;
  padding: 20px 5px;
  text-align: center;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`

export const CardHeaderWrapper = styled(CardHeader)`
  display: block !important;
  padding: 0px !important;
  margin-top: 1rem !important;
`

export const AppNameRow = styled(Row)`
  height: 80px;
`

export const AppNameCol = styled(Col)`
  margin: auto 0px;
`
const CategoryApp = ({
  item,
  uniqueSectionName = '',
  isFavorite,
  isRecentlyOpened,
  dataTestid
}) => {
  const { addToFavourite, removeFromFavourite } = useFavouriteApps()
  const trackAddToFavourite = useTrackEvent(appInsights, EventType.AddToFavourites)
  const { appendToken } = useSasToken()
  const appsFavorite = useSelector((state) => state.favoriteAppsReducer.favoriteApps)

  const { name, appIcon, uniqueName } = item || {}

  if (item === null || item === undefined || Object.keys(item).length === 0) {
    return null
  }

  const onMakeAppFavourite = async (item) => {
    try {
      const response = await addToFavourite(item)

      if (response && !response.errorReason !== '') {
        console.error(`An error occured while trying to favourite application ${item?.id}`)
      }
      trackAddToFavourite({
        properties: {
          appId: item.id,
          appName: item.name
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const onMakeRemoveFavourite = async (item) => {
    try {
      const response = await removeFromFavourite(item)

      if (response && !response.errorReason !== '') {
        console.error(`An error occured while trying to un-favourite application ${item?.id}`)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const addItemToFavourite = async (item) => {
    const isApplicationFav = appsFavorite && appsFavorite.find((app) => app?.id === item?.id)
    if (
      isApplicationFav &&
      isApplicationFav instanceof Object &&
      Object.keys(isApplicationFav).length
    ) {
      await onMakeRemoveFavourite(item)
    } else {
      await onMakeAppFavourite(item)
    }
  }

  return (
    <>
      <CardContainer className="shadow-sm card" data-testid={`${dataTestid}-${item.uniqueName}`}>
        {isRecentlyOpened ? (
          <RecentlyOpenedContainer />
        ) : (
          <FavouriteStarContainer onClick={() => addItemToFavourite(item)}>
            {!isFavorite ? (
              <IconStar size={24} color="var(--border-strong)" />
            ) : (
              <IconStar size={24} color="var(--color-warning)" />
            )}
          </FavouriteStarContainer>
        )}
        <ApplicationIconContainer
          to={{ pathname: `/apps/${uniqueName}`, state: { from: location.pathname } }}
          data-testid={`favApplication-${uniqueName}`}
          id={`fav-application-${uniqueName}-${uniqueSectionName}`}
          data-color={`${!isFavorite ? 'white' : 'yellow'}`}>
          <Avatar
            data-tooltip-id={`category-app-${item.uniqueName}`}
            content={appendToken(appIcon?.url)}
            shape="rounded"
            size="74px"
            className="mr-1 cart-img mx-auto border-0"
          />
          <CardTooltip id={`category-app-${item.uniqueName}`} key={item.uniqueName} item={item} />
        </ApplicationIconContainer>
        <ApplicationNameContainer>
          <ApplicationName>
            <Link to={{ pathname: `/apps/${uniqueName}`, state: { from: location.pathname } }}>
              {name}
            </Link>
          </ApplicationName>
        </ApplicationNameContainer>
        <ButtonContainer>
          <AppCtaButton app={item} />
        </ButtonContainer>
      </CardContainer>
    </>
  )
}

export default CategoryApp
